const statsTypes = {
  RESET_INVOICES_STATE: 'RESET_INVOICES_STATE',
  FETCH_INVOICES_BY_USER: {
    REQUEST: 'FETCH_INVOICES_BY_USER.REQUEST',
    SUCCESS: 'FETCH_INVOICES_BY_USER.SUCCESS',
    FAILURE: 'FETCH_INVOICES_BY_USER.FAILURE',
  },
};

export default statsTypes;
